import { render } from "./DeNovoMetastaticColorectalCancerView.vue?vue&type=template&id=33964f82"
import script from "./DeNovoMetastaticColorectalCancerView.vue?vue&type=script&lang=js"
export * from "./DeNovoMetastaticColorectalCancerView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__